<template>
    <div class="page">
      <div class="head-title">
        <div class="left">
          <ul class="breadcrumb">
            <li><a href="#">{{ $t("management") }} {{ $t("projects") }}</a></li>
            <li>-</li>
            <li><a href="#">{{ $t("extracts") }}</a></li>
            <li>-</li>
            <li><a class="active" href="#">{{ $t("تعديل") }} {{ $t("extract") }}</a></li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="head">
          <div class="head1">
            <h3>{{ $t("edit") }} {{ $t("extract") }}</h3>
          </div>
          <div class="head2">
            <button class="buttonconfirm" :disabled="disabled || isRemoving" @click.prevent="update">
              {{ $t("save") }}
            </button>
          </div>
        </div>
        <div class="body" v-if="!loading">
          <div class="part1">
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">نوع المستخلص</label>
              <div class="col-sm-2">
                <select class="form-select form-select-sm" v-model="extracttype">
                  <option value="دفعة">دفعة</option>
                  <option value="ضمان">ضمان</option>
                </select>
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("contractor") }} <span class="error-feedback">*</span></label>
              <div class="col-sm-4">
                <v-select :options="allcontractors" label="name" v-model="contractor"></v-select>
              </div>
              <label class="col-sm-2 col-form-label-sm">{{ $t("contracts") }} <span class="error-feedback">*</span></label>
              <div class="col-sm-4">
                <v-select :options="contracts" label="name" v-model="contract"></v-select>
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("project") }} <span class="error-feedback">*</span></label>
              <div class="col-sm-4">{{ contract?.project }}</div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("date") }} <span class="error-feedback">*</span></label>
              <div class="col-sm-4">
                <input type="date" class="form-control form-control-sm" v-model="date" />
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("amount") }} {{ $t("guarantee") }} %</label>
              <div class="col-sm-1">
                <input type="number" class="form-control form-control-sm" v-model="guarantee" />
              </div>
            </div>
            <div class="mb-2 row">
              استمارة للاعمال المنجزة للفترة
              <label class="col-sm-2 col-form-label-sm">{{ $t("from") }} <span class="error-feedback">*</span></label>
              <div class="col-sm-2">
                <input type="date" class="form-control form-control-sm" v-model="startdate" />
              </div>
              <label class="col-sm-2 col-form-label-sm">{{ $t("to") }} <span class="error-feedback">*</span></label>
              <div class="col-sm-2">
                <input type="date" class="form-control form-control-sm" v-model="enddate" />
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-1 col-form-label-sm">{{ $t("amount") }} {{ $t("contract") }} <span class="error-feedback">*</span></label>
              <div class="col-sm-3"><span class="amount" v-if="contract?.amount">{{ contract.amount }}</span></div>
              <label class="col-sm-1 col-form-label-sm">{{ $t("amount") }} {{ $t("extract") }} <span class="error-feedback">*</span></label>
              <div class="col-sm-3"><span class="amount" v-if="totalextract">{{ totalextract }}</span></div>
              <label class="col-sm-1 col-form-label-sm">اجمالى الضمان <span class="error-feedback">*</span></label>
              <div class="col-sm-3"><span class="amount" v-if="totalextractgar">{{ totalextractgar }}</span></div>
            </div>
            <hr />
            <h6>المستخلصات السابقة</h6>
            <table class="table" style="width: 50%; font-size: small">
              <thead>
                <tr>
                  <th>رقم البند</th>
                  <th>{{ $t("product") }}</th>
                  <th>السعر</th>
                  <th>الكمية السابقة</th>
                  <th>المبلغ المدفوع</th>
                  <th>مبلغ الضمان</th>
                  <th>مبلغ الضمان المدفوع</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x, id) in totaltrans" :key="x.sn">
                  <td>{{ id + 1 }}</td>
                  <td>{{ x.name }}</td>
                  <td>{{ x.buyp }}</td>
                  <td>{{ x.paidq }}</td>
                  <td>{{ x.paid }}</td>
                  <td>{{ x.guarantee }}</td>
                  <td><span v-if="x.paidguarantee > 0">{{ x.paidguarantee }}</span></td>
                </tr>
              </tbody>
            </table>
            <hr />
            <table class="table" style="width: 100%; font-size: small" v-if="extracttype === 'دفعة'">
              <thead>
                <tr>
                  <th>رقم البند</th>
                  <th style="width: 12%">{{ $t("product") }}</th>
                  <th style="width: 12%">{{ $t("classification") }}</th>
                  <th>{{ $t("description") }}</th>
                  <th style="width: 10%">{{ $t("quantity") }}</th>
                  <th style="width: 10%">{{ $t("unit type") }}</th>
                  <th>{{ $t("price") }}</th>
                  <th>{{ $t("tax") }}</th>
                  <th style="width: 10%">{{ $t("quantity") }}</th>
                  <th>مبلغ السداد</th>
                  <th>الضمان</th>
                  <th>الصافي</th>
                  <th>الضريبة</th>
                  <th>{{ $t("total") }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x, id) in contdata" :key="x.sn">
                  <td>{{ id + 1 }}</td>
                  <td>{{ x.pronamear }}</td>
                  <td>{{ x.classname }}</td>
                  <td>{{ x.description }}</td>
                  <td>{{ x.quantity }}</td>
                  <td>{{ x.unittype }}</td>
                  <td>{{ x.buyp }}</td>
                  <td>{{ x.tax }} %</td>
                  <td><input type="number" v-model="x.paidq" style="width: 100%;" @change="caltax(id)" /></td>
                  <td>{{ x.paid }}</td>
                  <td><input type="number" v-model="x.guarantee" @change="calgar(id)" /></td>
                  <td>{{ x.paidgar }}</td>
                  <td>{{ x.taxamountpaid }}</td>
                  <td>{{ x.total }}</td>
                  <td><a href="#" @click.prevent="del(id)"><i class="bi bi-x-circle-fill"></i></a></td>
                </tr>
              </tbody>
            </table>
            <table class="table" style="width: 100%; font-size: small" v-if="extracttype === 'ضمان'">
              <thead>
                <tr>
                  <th>رقم البند</th>
                  <th style="width: 12%">{{ $t("product") }}</th>
                  <th style="width: 12%">{{ $t("classification") }}</th>
                  <th>{{ $t("description") }}</th>
                  <th style="width: 10%">{{ $t("quantity") }}</th>
                  <th style="width: 10%">{{ $t("unit type") }}</th>
                  <th>{{ $t("price") }}</th>
                  <th>{{ $t("tax") }}</th>
                  <th>سداد الضمان</th>
                  <th>الضريبة</th>
                  <th>الاجمالى</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x, id) in contdata" :key="x.sn">
                  <td>{{ id + 1 }}</td>
                  <td>{{ x.pronamear }}</td>
                  <td>{{ x.classname }}</td>
                  <td>{{ x.description }}</td>
                  <td>{{ x.quantity }}</td>
                  <td>{{ x.unittype }}</td>
                  <td>{{ x.buyp }}</td>
                  <td>{{ x.tax }} %</td>
                  <td><input type="number" v-model="x.paidguarantee" style="width: 100%;" @change="caltax2(id)" /></td>
                  <td>{{ x.taxpaidgar }}</td>
                  <td>{{ x.tpaidgar }}</td>
                </tr>
              </tbody>
            </table>
            <!-- Existing Attachments Display -->
            <div class="mb-2 row" v-if="fileURLs.length > 0">
              <label for="existing-attachments" class="col-sm-2 col-form-label-sm">{{ $t("existing attachments") }}</label>
              <div class="col-sm-5">
                <ul class="attachment-list">
                  <li v-for="(attachment, index) in fileURLs" :key="index">
                    <a :href="getAttachmentUrl(attachment.name)" target="_blank" class="attachment-link">
                      {{ attachment.name }}
                    </a>
                    <button
                      class="btn btn-danger btn-sm"
                      @click="confirmRemoveAttachment(index, attachment.name)"
                      :disabled="isRemoving"
                    >
                      <span v-if="isRemoving && removingIndex === index" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span v-else>X</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <!-- New Attachments Input -->
            <div class="mb-2 row">
              <label for="attachments" class="col-sm-2 col-form-label-sm">{{ $t("new attachments") }}</label>
              <div class="col-sm-5">
                <input type="file" class="form-control" id="attachments" multiple @change="handleFiles($event)" :disabled="isRemoving" />
                <small v-if="attachments.length > 0">{{ attachments.length }} file(s) selected</small>
              </div>
            </div>
          </div>
        </div>
        <div v-else>Loading...</div>
      </div>
    </div>
  </template>

  <script>
  import store from "@/store";
  import useValidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import axios from "axios";
  import Swal from "sweetalert2";
  import { mapActions } from "vuex";
  import vSelect from "vue-select";

  export default {
    components: { vSelect },
    async mounted() {
      this.loading = true;
      try {
        const result1 = await axios.get("/projects/allcontractors");
        if (result1.status === 200) {
          this.allcontractors = [...result1.data.data];
        }
        await this.fetchExtract();
      } catch (error) {
        console.error("Error during mount:", error);
      } finally {
        this.loading = false;
      }
    },
    props: ["css"],
    data() {
      return {
        loading: false,
        disabled: false,
        isRemoving: false,
        removingIndex: null,
        v$: useValidate(),
        extractId: this.$route.params.id,
        allcontractors: [],
        contracts: [],
        contdata: [],
        contractor: null,
        contract: null,
        date: "",
        startdate: "",
        enddate: "",
        guarantee: 0,
        totalextract: "",
        totalextractgar: "",
        totaltrans: [],
        extracttype: "دفعة",
        attachments: [], // New files selected by user
        fileURLs: [], // Existing attachments from backend
      };
    },
    validations() {
      return {
        contract: { required },
        date: { required },
      };
    },
    methods: {
      handleFiles(event) {
        this.attachments = Array.from(event.target.files);
      },
      getAttachmentUrl(name) {
        return `${store.state.imgurl}/extract_attachments/${name}`; // Adjust based on your server setup
      },
      async confirmRemoveAttachment(index, fileName) {
        const result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("You won't be able to revert this!"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes, delete it!"),
          cancelButtonText: this.$t("Cancel"),
        });

        if (result.isConfirmed) {
          await this.removeAttachment(index, fileName);
        }
      },
      async removeAttachment(index, fileName) {
        this.isRemoving = true;
        this.removingIndex = index;
        try {
          const response = await axios.delete(`/projects/extract-attachments/${this.extractId}`, {
            data: {
              fileName: fileName,
              user: { user: { cnum: JSON.stringify({ cnum: store.state.randp.username }) } },
            },
          });

          if (response.status === 200) {
            this.fileURLs.splice(index, 1);
            Swal.fire({
              toast: true,
              position: "top",
              icon: "success",
              title: this.$t("Attachment deleted successfully"),
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        } catch (error) {
          console.error("Error removing attachment:", error);
          Swal.fire({
            icon: "error",
            title: this.$t("Error"),
            text: error.response?.data?.message || this.$t("Failed to delete attachment"),
          });
        } finally {
          this.isRemoving = false;
          this.removingIndex = null;
        }
      },
      async fetchExtract() {
        try {
          const response = await axios.get(`/projects/getextract/${this.extractId}`);
          if (response.status === 200) {
            const extract = response.data.data[0];
            if (extract.status === "confirmed") {
              Swal.fire({
                icon: "error",
                title: "Cannot Edit Confirmed Extract",
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 3000,
              });
              this.redirectTo({ val: "AllExtracts" });
              return;
            }
            this.extracttype = extract.type;
            this.contractor = { cid: extract.contractorid, name: extract.contractorname };
            const contractsResult = await axios.get(`/projects/getconstractorcontract/${this.contractor.cid}`);
            if (contractsResult.status === 200) {
              this.contracts = [...contractsResult.data.data];
              this.contract = this.contracts.find(c => c.cid === extract.contractid) || {
                cid: extract.contractid,
                name: extract.contract,
                project: extract.project,
                projectid: extract.projectid,
                amount: extract.amount,
                contdata: extract.contdata,
                guarantee: extract.guarantee,
              };
            }
            this.date = extract.date;
            this.startdate = extract.startdate;
            this.enddate = extract.enddate;
            this.guarantee = Number(extract.guarantee) || 0;
            this.totalextract = extract.amount || "0";
            this.totalextractgar = extract.guaranteeamount || "0";
            this.contdata = [...JSON.parse(extract.contdata || "[]")];
            this.totaltrans = [...JSON.parse(extract.old || "[]")];
            this.fileURLs = extract.attachments ? JSON.parse(extract.attachments) : [];

            this.contdata.forEach(item => {
              const oldItem = this.totaltrans.find(t => t.sn === item.sn && t.buyp === item.buyp);
              if (oldItem) {
                item.paidq = oldItem.paidq || item.paidq;
                item.guarantee = oldItem.guarantee || item.guarantee;
                item.paidguarantee = oldItem.paidguarantee || item.paidguarantee;
                if (this.extracttype === "دفعة") {
                  this.caltax(this.contdata.indexOf(item));
                } else if (this.extracttype === "ضمان") {
                  this.caltax2(this.contdata.indexOf(item));
                }
              }
            });

            if (this.contract?.cid) {
              const transResult = await axios.get(`/projects/getconstractorcontracttran/${this.contract.cid}`);
              if (transResult.status === 200) {
                const trans = transResult.data.data;
                let alltrans = [];
                if (trans.length > 0) {
                  for (let i = 0; i < trans.length; i++) {
                    alltrans = [...alltrans, ...JSON.parse(trans[i].contdata)];
                  }
                }
                this.totaltrans = [];
                for (let x = 0; x < this.contdata.length; x++) {
                  const element = this.contdata[x];
                  const data = alltrans.filter((t) => t.sn === element.sn && t.buyp === element.buyp);
                  const totalpaid = data.reduce((acc, array) => acc + Number(array.total || 0), 0);
                  const totalpaidq = data.reduce((acc, array) => acc + Number(array.paidq || 0), 0);
                  const totalgar = data.reduce((acc, array) => acc + Number(array.guarantee || 0), 0);
                  const totalgarpaid = data.reduce((acc, array) => acc + Number(array.tpaidgar || 0), 0);
                  this.totaltrans.push({
                    name: element.pronamear,
                    sn: element.sn,
                    paid: totalpaid,
                    paidq: totalpaidq,
                    buyp: element.buyp,
                    guarantee: totalgar,
                    paidguarantee: totalgarpaid,
                  });
                }
              }
            }
          }
        } catch (error) {
          console.error("Error fetching extract:", error);
        }
      },
      async update() {
        this.v$.$validate();
        if (!this.v$.$error && !this.isRemoving) {
          this.disabled = true;
          try {
            // Step 1: Update extract data
            const updateData = {
              username: store.state.randp.username,
              name: this.contract.name,
              contract: this.contract.name,
              contractid: this.contract.cid,
              project: this.contract.project,
              projectid: this.contract.projectid,
              startdate: this.startdate,
              enddate: this.enddate,
              amount: this.totalextract,
              contractorname: this.contractor.name,
              contractorid: this.contractor.cid,
              contdata: JSON.stringify(this.contdata),
              date: this.date,
              old: JSON.stringify(this.totaltrans),
              guarantee: this.guarantee,
              guaranteeamount: this.totalextractgar,
              amountwout: this.totalextract,
              type: this.extracttype,
              attachments: JSON.stringify(this.fileURLs),
            };
            const updateResult = await axios.put(`/projects/updateextract/${this.extractId}`, updateData);

            if (updateResult.status === 200) {
              // Step 2: Upload new attachments if any
              if (this.attachments.length > 0) {
                for (let i = 0; i < this.attachments.length; i++) {
                  const file = this.attachments[i];
                  const formData = new FormData();
                  const nameParts = file.name.split(".");
                  const newName = `${store.state.randp.username}_${this.extractId}_${Date.now()}_${i}.${nameParts[nameParts.length - 1]}`;
                  formData.append("attachments", file, newName);

                  const uploadResult = await axios.patch(
                    `/extract-attachments/${this.extractId}`,
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                  );

                  if (uploadResult.status === 200) {
                    this.fileURLs.push(...uploadResult.data.files);
                  }
                }

                // Step 3: Update extract with new file URLs
                await axios.put(`/projects/updateextract/${this.extractId}`, {
                  ...updateData,
                  attachments: JSON.stringify(this.fileURLs),
                });
              }

              Swal.fire({
                icon: "success",
                title: "Extract Updated Successfully",
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 3000,
              });
              this.redirectTo({ val: "AllExtracts" });
            }
          } catch (error) {
            console.error("Error updating extract:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.response?.data?.message || "Failed to update extract",
            });
          } finally {
            this.disabled = false;
          }
        } else if (this.isRemoving) {
          Swal.fire({
            icon: "warning",
            title: this.$t("Please wait"),
            text: this.$t("An attachment is being removed"),
          });
        }
      },
      del(id) {
        this.contdata.splice(id, 1);
        this.calculateTotals();
      },
      caltax(id) {
        const item = this.contdata[id];
        if (item.tax > 0) {
          const amount = item.paidq * item.buyp;
          item.paid = Number(amount).toFixed(2);
          item.guarantee = amount * (this.guarantee / 100);
          item.paidgar = amount - item.guarantee;
          item.taxamountpaid = Number((item.paidgar * item.tax) / 100).toFixed(2);
          item.total = Number(Number(item.paidgar) + Number(item.taxamountpaid)).toFixed(2);
        } else {
          const amount = item.paidq * item.buyp;
          item.paid = Number(amount).toFixed(2);
          item.taxamountpaid = 0;
          item.guarantee = amount * (this.guarantee / 100);
          item.paidgar = amount - item.guarantee;
          item.total = Number(Number(item.paidgar) + Number(item.taxamountpaid)).toFixed(2);
        }
        this.calculateTotals();
      },
      caltax2(id) {
        const item = this.contdata[id];
        if (item.tax > 0) {
          item.taxpaidgar = Number((item.paidguarantee * item.tax) / 100).toFixed(2);
          item.tpaidgar = Number(item.paidguarantee) + Number(item.taxpaidgar);
        } else {
          item.taxpaidgar = 0;
          item.tpaidgar = Number(item.paidguarantee);
        }
        this.calculateTotals();
      },
      calgar(id) {
        const item = this.contdata[id];
        if (item.tax > 0) {
          const amount = item.paidq * item.buyp;
          item.paid = Number(amount).toFixed(2);
          item.paidgar = amount - item.guarantee;
          item.taxamountpaid = Number((item.paidgar * item.tax) / 100).toFixed(2);
          item.total = Number(Number(item.paidgar) + Number(item.taxamountpaid)).toFixed(2);
        } else {
          const amount = item.paidq * item.buyp;
          item.paid = Number(amount).toFixed(2);
          item.taxamountpaid = 0;
          item.paidgar = amount - item.guarantee;
          item.total = Number(Number(item.paidgar) + Number(item.taxamountpaid)).toFixed(2);
        }
        this.calculateTotals();
      },
      calculateTotals() {
        this.totalextract = this.contdata.reduce((acc, array) => acc + Number(array.total || array.tpaidgar || 0), 0);
        this.totalextractgar = this.contdata.reduce((acc, array) => acc + Number(array.guarantee || array.paidguarantee || 0), 0);
      },
      ...mapActions(["redirectTo"]),
    },
    watch: {
      async contractor(newContractor) {
        if (newContractor && newContractor.cid) {
          try {
            const result = await axios.get(`/projects/getconstractorcontract/${newContractor.cid}`);
            if (result.status === 200) {
              this.contracts = [...result.data.data];
              if (!this.contract || !this.contracts.some(c => c.cid === this.contract.cid)) {
                this.contract = null;
                this.contdata = [];
                this.totaltrans = [];
              }
            }
          } catch (error) {
            console.error("Error fetching contracts:", error);
          }
        }
      },
      async contract(newContract) {
        if (newContract && newContract.cid && this.contracts.length > 0) {
          this.guarantee = Number(newContract.guarantee) || 0;
          if (this.contdata.length === 0) {
            this.contdata = [...JSON.parse(newContract.contdata || "[]")];
          }
          try {
            const result = await axios.get(`/projects/getconstractorcontracttran/${newContract.cid}`);
            if (result.status === 200) {
              const trans = result.data.data;
              let alltrans = [];
              if (trans.length > 0) {
                for (let i = 0; i < trans.length; i++) {
                  alltrans = [...alltrans, ...JSON.parse(trans[i].contdata)];
                }
              }
              this.totaltrans = [];
              for (let x = 0; x < this.contdata.length; x++) {
                const element = this.contdata[x];
                const data = alltrans.filter((t) => t.sn === element.sn && t.buyp === element.buyp);
                const totalpaid = data.reduce((acc, array) => acc + Number(array.total || 0), 0);
                const totalpaidq = data.reduce((acc, array) => acc + Number(array.paidq || 0), 0);
                const totalgar = data.reduce((acc, array) => acc + Number(array.guarantee || 0), 0);
                const totalgarpaid = data.reduce((acc, array) => acc + Number(array.tpaidgar || 0), 0);
                this.totaltrans.push({
                  name: element.pronamear,
                  sn: element.sn,
                  paid: totalpaid,
                  paidq: totalpaidq,
                  buyp: element.buyp,
                  guarantee: totalgar,
                  paidguarantee: totalgarpaid,
                });
              }
            }
          } catch (error) {
            console.error("Error fetching contract transactions:", error);
          }
        }
      },
      guarantee() {
        this.calculateTotals();
      },
    },
  };
  </script>

  <style lang="scss" scoped>
  .page {
    direction: v-bind("css.EN");
    padding: 0.5%;
  }

  .main {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 1%;
  }

  .body {
    padding: 1%;
  }

  .head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
  }

  .head1 {
    width: 60%;
  }

  .head2 {
    width: 40%;
    text-align: center;
  }

  .head2 button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    font-size: small;
    width: 30%;
  }

  .amount {
    background-color: gray;
    color: white;
    padding: 2%;
  }

  .attachment-list {
    list-style: none;
    padding: 0;
  }

  .attachment-list li {
    display: flex;
    align-items: center;
    margin: 5px 0;
  }

  .attachment-link {
    color: #007bff;
    text-decoration: none;
    margin-right: 10px;
  }

  .attachment-link:hover {
    text-decoration: underline;
  }

  .btn-sm {
    padding: 2px 5px;
    font-size: 12px;
  }

  .btn-sm:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  </style>
